export const ProductCategoryEnum = {
  ModularDevices: 'modular-devices',
  DistributionBoard: 'distribution-board',
  Clamp: 'clamp'
};
